<template>
  <div>
    <v-container fluid>
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12">
          <v-card outlined min-height="110vh">
            <v-card-title class="d-flex justify-space-between">
              <div class="text-h5">Your Business Network</div>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6" sm="6" md="4" class="d-flex align-center">
                  <v-btn
                    class="pa-5 issue-new-card"
                    rounded
                    color="primary"
                    elevation="0"
                    @click="showFormDialog = !showFormDialog"
                  >
                    <v-icon left>mdi-plus</v-icon> Generate QR code and form
                  </v-btn>
                </v-col>

                <v-col cols="6" md="4" offset="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search for a source/event"
                    outlined
                    single-line
                    hide-details
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headers"
                 @click:row="handleEditForm"
                 class="networks-table"
                :search="search"
                :items="allBusinessNetworks"
                :items-per-page="8"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template v-slot:[`item.created`]="{ item }">
                  <span>{{
                    new Date(item.created).toLocaleDateString("en-AU")
                  }}</span>
                </template>
                <template v-slot:[`item.noOfRegistrants`]="{ item }">
                  <span>{{ item.registrants.length }}</span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-menu transition="slide-y-transition" bottom left offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="handleEditForm(item)">
                        <v-list-item-title>Edit</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="handleDownloadQRCode(item)">
                        <v-list-item-title>Download QR Code</v-list-item-title>
                      </v-list-item> -->
                       <v-list-item @click="handleViewRegistrants(item)">
                        <v-list-item-title>View Registrants</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="handleCopyLink(item)">
                        <v-list-item-title>Copy unique link</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="handleDelete(item)">
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <GenerateQRCodeAndFormDialog
      v-if="showFormDialog"
      :show="showFormDialog"
      @close="showFormDialog = false"
    />
  </div>
</template>

<script>
import GenerateQRCodeAndFormDialog from "../components/YourBusinessNetwork/GenerateQRCodeAndFormDialog.vue";
import YourBusinessNetwork from "@/models/YourBusinessNetwork";
import { mapGetters, mapActions } from "vuex";
import Utility from "@/shared/utility";
import {onSnapshot, where} from "firebase/firestore";
import {deleteYourBusinessNetworkDoc, queryYourBusinessNetworkCollection} from "@/shared/firebase_utils";
export default {
  components: {
    GenerateQRCodeAndFormDialog,
  },
  data() {
    return {
      showFormDialog: false,
      allBusinessNetworks: [],
      unsubscribeBusinessNetworkSnapshot: null,
      search: "",
      sortBy: "created",
      sortDesc: true,
    };
  },
  async created() {
    this.unsubscribeBusinessNetworkSnapshot = onSnapshot(queryYourBusinessNetworkCollection(
        where("businessProfileId", "==", this.selectedBusinessProfileId)),
        (querySnapshot) => {
        const changes = querySnapshot.docChanges();
        this.handleBusinessNetworkChanges(changes);
      });
  },
  computed: {
    ...mapGetters(["selectedBusinessProfileId", "currentBusinessNetwork"]),
    headers() {
      let headerElements = [
        {
          text: "Source/Event Name",
          align: "start",
          value: "eventName",
        },
        { text: "Registrants", value: "noOfRegistrants" },
        { text: "Created By", value: "createdBy" },
        { text: "Created", value: "created", align: "center" },
      ];
      headerElements.push({
        text: "Actions",
        value: "actions",
        align: "center",
      });
      return headerElements;
    },
  },
  methods: {
    ...mapActions([
      "initializeYourBusinessNetwork",
      "getBusinessNetworks",
      "showSnackbar",
      "setCurrentBusinessNetwork",
    ]),
    handleBusinessNetworkChanges(changes) {
      changes.forEach((change) => {
        let addedNetwork;
        if (change.type === "added" || change.type == "modified") {
          addedNetwork = YourBusinessNetwork.fromFireStore(change.doc);
        }
        if (change.type === "added") {
          if (
            this.allBusinessNetworks.length != 0 &&
            addedNetwork.createdAt > this.allBusinessNetworks[0].createdAt
          ) {
            this.allBusinessNetworks.unshift(addedNetwork);
          } else {
            this.allBusinessNetworks.push(addedNetwork);
          }
        } else if (change.type == "modified") {
          //Replace the old object within the array with the modified object
          this.allBusinessNetworks.forEach((item, index) => {
            if (item.id == change.doc.id) {
              this.allBusinessNetworks.splice(index, 1, addedNetwork);
            }
          });
        } else if (change.type == "removed") {
          //Remove the object from the array
          this.allBusinessNetworks.forEach((item, index) => {
            if (item.id == change.doc.id) {
              this.allBusinessNetworks.splice(index, 1);
            }
          });
        }
      });
    },
    handleCopyLink(item) {
      Utility.copyToClipboard(item.dynamicLink);
      this.showSnackbar({ show: true, text: "Link copied to clipboard!" });
    },
    handleEditForm(item) {
      this.setCurrentBusinessNetwork(item);
      this.$router.push({
        name: "EditBusinessNetwork",
        params: { id: item.id, tab:0 },
      });
    },
    handleViewRegistrants(item){
       this.setCurrentBusinessNetwork(item);
      this.$router.push({
        name: "EditBusinessNetwork",
        params: { id: item.id, tab:1 },
      });
    },
    async handleDelete(item) {
      await deleteYourBusinessNetworkDoc(item.id);
      this.showSnackbar({ show: true, text: "Deleted Successfully!" });
    },
  },
};
</script>

<style>

.networks-table tr td {
 
  
  cursor: pointer;
}
</style>